import React, { useState } from "react";
import AssetInformationGrid from "@components/grid/AssetInformationGrid";
import { useSetRecoilState, useRecoilValue } from "recoil";
import {
  selectedIndexTickerState,
  operationListState,
} from "@states/indexGlobal";
import { COLUMNS } from "@pages/asset/define";

import { Toolbar } from "./Toolbar";
import useSearchHook from "../../../detail/useSearchHook";
import { Grid } from "@mui/material";
import OperationDownload from "../OperationDownload";

function EtfTable({ onChangeChecked, onSelectAsset }) {
  const [searchText, setSearch] = useState("");
  const setSelectedEtfTicker = useSetRecoilState(selectedIndexTickerState);
  const operationList = useRecoilValue(operationListState);
  const [gridData, setGridData] = useState(operationList);

  const [updateSearch] = useSearchHook(operationList, setSearch, setGridData);

  return (
    <>
      <Grid container justifyContent="space-between">
        <Grid item xs={6} md={4}>
          <Toolbar
            text={searchText}
            onChangeText={updateSearch}
            market={"미국"}
          />
        </Grid>
        {/* <Grid item>
          <OperationDownload />
        </Grid> */}
      </Grid>
      <AssetInformationGrid
        market={"INDEXGLOBAL"}
        onSelectAsset={(asset) => {
          setSelectedEtfTicker(asset);
          if (onSelectAsset) {
            onSelectAsset(asset);
          }
        }}
        columns={COLUMNS.INDEXGLOBAL}
        data={gridData}
        onChangeChecked={onChangeChecked}
      />
    </>
  );
}

export default EtfTable;
